$(document).ready(function () {
  function checkScrollable() {
    if ($(document).height() > $(window).height()) {
      $('html').addClass('is-scrollable');
    } else {
      $('html').removeClass('is-scrollable');
    }
  }

  checkScrollable();

  $(window).on('resize', function () {
    checkScrollable();
  });
});
